import {
  faAlarmClock,
  faArchive,
  faBox,
  faBoxFull,
  faBuilding,
  faCog,
  faCoins,
  faCopy,
  faFileChartLine,
  faFileImage,
  faFileInvoiceDollar,
  faHandsHeart,
  faImage,
  faImages,
  faPlug,
  faStoreAlt,
  faUsers,
} from '@fortawesome/pro-light-svg-icons'

type GenerateNavItems = {
  agencyAdminPagesPermissions: boolean,
  agencyAdminUserPermissions: boolean,
  hasMultipleAgencies: boolean,
  selectedAgencyId: number | 'all',
}

const generateNavigationItems = (params: GenerateNavItems) => {
  const {
    agencyAdminPagesPermissions, agencyAdminUserPermissions, hasMultipleAgencies, selectedAgencyId,
  } = params

  const baseHref = `#/agencies/${selectedAgencyId}/manage`

  return {
    sections: [
      {
        key: 'agency',
        title: 'AGENCY',
        visible: agencyAdminPagesPermissions || agencyAdminUserPermissions,
        items: [
          {
            href: hasMultipleAgencies ? `${baseHref}/agencies` : `${baseHref}/details`,
            icon: faBuilding,
            key: 'agency-details',
            title: hasMultipleAgencies ? 'Agencies' : 'Agency Details',
            visible: agencyAdminPagesPermissions,
          },
          {
            href: `${baseHref}/users`,
            icon: faUsers,
            key: 'users',
            title: 'Agents & Users',
            visible: agencyAdminUserPermissions,
          },
          {
            href: `${baseHref}/customDeadlines`,
            icon: faAlarmClock,
            key: 'custom-deadlines',
            title: 'Alerts & Deadlines',
            visible: agencyAdminPagesPermissions,
          },
          {
            href: `${baseHref}/integrations`,
            icon: faPlug,
            key: 'integrations',
            title: 'Integrations',
            visible: agencyAdminPagesPermissions,
          },
          {
            href: `${baseHref}/reporting`,
            icon: faFileChartLine,
            key: 'reporting',
            title: 'Reporting',
            visible: agencyAdminPagesPermissions,
          },
          {
            href: `${baseHref}/settings`,
            icon: faCog,
            key: 'settings',
            title: 'Settings',
            visible: agencyAdminPagesPermissions,
          },
          {
            href: `${baseHref}/teams`,
            icon: faHandsHeart,
            key: 'teams',
            title: 'Teams',
            visible: agencyAdminPagesPermissions,
          },
        ],
      },
      {
        key: 'marketing',
        title: 'MARKETING',
        visible: agencyAdminPagesPermissions,
        items: [
          {
            href: `${baseHref}/orderBundles`,
            icon: faBoxFull,
            key: 'order-bundles',
            title: 'Bundles',
            visible: agencyAdminPagesPermissions,
          },
          {
            href: `${baseHref}/customItems`,
            icon: faStoreAlt,
            key: 'custom-items',
            title: 'Custom Items',
            visible: agencyAdminPagesPermissions,
          },
          {
            href: `${baseHref}/imageSettings`,
            icon: faImage,
            key: 'image-settings',
            title: 'Image Settings',
            visible: agencyAdminPagesPermissions,
          },

          {
            href: `${baseHref}/providerPackages`,
            icon: faBoxFull,
            key: 'packages',
            title: 'Packages',
            visible: agencyAdminPagesPermissions,
          },
          {
            href: `${baseHref}/providerPriceLists`,
            icon: faFileInvoiceDollar,
            key: 'price-lists',
            title: 'Price Lists',
            visible: agencyAdminPagesPermissions,
          },
          {
            href: `${baseHref}/products`,
            icon: faBox,
            key: 'products',
            title: 'Products',
            visible: agencyAdminPagesPermissions,
          },
          {
            href: `${baseHref}/campaignQuoteTemplates`,
            icon: faCopy,
            key: 'quote-templates',
            title: 'Quote Templates',
            visible: agencyAdminPagesPermissions,
          },
          {
            href: `${baseHref}/taskPricing`,
            icon: faCoins,
            key: 'task-pricing',
            title: 'Task Pricing',
            visible: agencyAdminPagesPermissions,
          },
        ],
      },
      {
        key: 'libraries',
        title: 'LIBRARIES',
        visible: agencyAdminPagesPermissions,
        items: [
          {
            href: `${baseHref}/assetLibraries`,
            icon: faArchive,
            key: 'libraries-assets',
            title: 'Document Library',
            visible: agencyAdminPagesPermissions,
          },
          {
            href: `${baseHref}/imageLibraries`,
            icon: faImages,
            key: 'libraries-images',
            title: 'Image Library',
            visible: agencyAdminPagesPermissions,
          },
          {
            href: `${baseHref}/savedArtworks`,
            icon: faFileImage,
            key: 'saved-artworks',
            title: 'Saved Artworks',
            visible: agencyAdminPagesPermissions,
          },
          {
            href: `${baseHref}/templateGallery`,
            icon: faFileImage,
            key: 'template-gallery',
            title: 'Template Gallery',
            visible: agencyAdminPagesPermissions,
          },
        ],
      },
    ],
  }
}

export default generateNavigationItems
